// import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { Form, Typography } from 'antd';
import { Wrapper } from './styledComponents';
import './style.less';
import { Link, useLocation } from 'react-router-dom';
import imageSource from 'assets/images/email.svg';

function ForgotLoginSuccess() {
  const { t } = useTranslation();
  const location = useLocation() as {
    state: {
      countryCode: string;
      type: string;
      value: string;
      loginId: string;
      flag: string;
    };
  };
  function maskEmail(email: string) {
    if (!email) return '';
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    const visibleDigits = 2;
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);
    return startDigits + maskedPart + endDigits;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography.Title level={3} style={{ color: '#fff', marginBottom: 30 }}>
        {t('life.forgetLoginId.headline')}
      </Typography.Title>
      <Wrapper
        className="wrapper_success"
        style={{
          borderRadius: '0',
          width: '100%',
          background: '#fff',
          margin: 0,
          padding: 0,
          paddingTop: 20,
          paddingBottom: 100,
          minHeight: '797px',
          boxSizing: 'border-box',
        }}
      >
        <img src={imageSource} alt="forgot-icon" style={{ width: 176, height: 176 }} />
        <div
          style={{
            fontSize: 26,
            fontWeight: 'normal',
            color: 'black',
            margin: '20px 0',
            lineHeight: '29px',
            fontFamily: 'Roboto400',
          }}
        >
          {t(`life.forgetLoginId.success1.${location.state.type}`)}
          {location.state.type === 'phone' && <>{location.state.countryCode} &nbsp;&nbsp;</>}
          {location.state.type === 'email' ? maskEmail(location.state.value) : maskPhoneNumber(location.state.value)}
        </div>
        <div
          style={{
            width: '80%',
            fontSize: '20px',
            fontWeight: 600,
            color: 'red',
            margin: '20px auto 40px',
            lineHeight: '29px',
            fontFamily: 'Roboto600',
          }}
        >
          {location.state.type === 'phone' && (
            <>{location.state.flag == 'EB' ? t('sms.forgotIdOtpEb') : t('sms.forgotIdOtpLife')}</>
          )}
        </div>
        <Form>
          <Link
            style={{
              fontWeight: 'normal',
              marginLeft: 4,
              marginRight: 4,
              color: '#C21A17',
              textDecoration: 'underline',
              fontFamily: 'Roboto400',
              fontSize: 17,
            }}
            to="/login"
          >
            {t('life.forgetLoginId.BackLogin')}
          </Link>
        </Form>
      </Wrapper>
    </div>
  );
}

export default ForgotLoginSuccess;
